import { render, staticRenderFns } from "./CitationUploader.vue?vue&type=template&id=21316c14"
import script from "./CitationUploader.vue?vue&type=script&lang=ts"
export * from "./CitationUploader.vue?vue&type=script&lang=ts"
import style0 from "./CitationUploader.vue?vue&type=style&index=0&id=21316c14&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports